// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__iVx8m","sm":"styles_sm__VwQfu","md":"styles_md__Y9XKS","lg":"styles_lg__QEnLD","adaptive":"styles_adaptive__fesO4","closeIcon":"styles_closeIcon__aacOn"};